import { NextSeo } from 'next-seo'

import { I_AM_TYPE_SELECT_OPTIONS } from 'const/i-am-options'
import { ContactUs } from 'components/contact-us'

export const ContactUsMain = () => {
  return (
    <>
      <NextSeo title="Contact Us" />
      <ContactUs
        iAmList={I_AM_TYPE_SELECT_OPTIONS}
        description="If you have any questions or inquiries a member of the team will always be happy to help.  Feel free to contact us by completing our help request form and we will be sure to get back to you as soon as possible."
        contactSectionTitle="General inquiries"
        email="info@rezitrade.com"
      />
    </>
  )
}
